import React from 'react';
import ReviewLayout from '../Templates/ReviewLayout';

const AdminViewTeam = () => {
    const verticalMenuItems = [
        { key: '1', title: 'ACE - Individual Awards', path: '/admin/view/individual' },
        { key: '2', title: 'ACE - Team Awards', path: '/admin/view/team' },
    ];


    return (
        <ReviewLayout
            subtitle="Admin View"
            stage="11"
            stageName="Team Award Nominees"
            verticalMenuItems={verticalMenuItems}
            currentStage={-1}
        />
    );
};

export default AdminViewTeam;
